module.exports = __webpack_public_path__ + "media/images/minus-2d9a148ff844038a26b97312bbfddee2.svg";